import { QueryClient } from '@tanstack/react-query';

import { getErrorMessage } from '@core/api/error-handler';
import { QUERY_KEYS } from '@src/shared/constants/query-keys';
import { showToast } from '@src/shared/utils/helpers/show-toast';

const QUERIES_NOT_REQUIRE_ORGANIZATION = [QUERY_KEYS.getMemberships];

// Custom query key hash function:
// - If the query is in QUERIES_NOT_REQUIRE_ORGANIZATION, use the raw query key (no org scoping).
// - Otherwise, prefix the key with the current org slug from the URL so caches are isolated per organization.
// GOAL: Isolate caches per organization.
const queryKeyHashFn = (queryKey: readonly unknown[]) => {
  const queryNotRequireOrg = queryKey.find((k) =>
    QUERIES_NOT_REQUIRE_ORGANIZATION.includes(k as string)
  );
  if (queryNotRequireOrg) return JSON.stringify(queryKey);

  const orgSlug = window.location.pathname.split('/')[1];
  return `${orgSlug}-${JSON.stringify(queryKey)}`;
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      queryKeyHashFn,
      refetchOnWindowFocus: false,
    },

    mutations: {
      onError: (error) => {
        showToast({
          title: 'Error occurred',
          description: getErrorMessage(error),
          variant: 'error',
        });
      },
    },
  },
});
